import { render, staticRenderFns } from "./highSchoolProfile.vue?vue&type=template&id=646e2177&scoped=true&"
import script from "./highSchoolProfile.vue?vue&type=script&lang=js&"
export * from "./highSchoolProfile.vue?vue&type=script&lang=js&"
import style0 from "./highSchoolProfile.vue?vue&type=style&index=0&id=646e2177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e2177",
  null
  
)

export default component.exports